import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { VerifyLoginBuilder } from './verify-login.builder';
import { I2gNgTrackingService, ITrackingObject } from 'i2g-ng-tracking';
import { merge, Observable } from 'rxjs';
import { filter, map, shareReplay, take, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { AccountDispatcher } from '../../store/dispatchers';
import { LOGIN_ATTEMPT_ID, VERIFICATION_CODE } from '../../account.data';
import { AccountStore } from '../../store/stores';
import { LoginAttemptResult } from '../../store/models';
import { IconSizesEnum, IIcon } from 'i2g-ng-ui';

@Component({
  selector: 'app-verify-login',
  templateUrl: './verify-login.component.html',
  styleUrls: ['./verify-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [VerifyLoginBuilder],
})
export class VerifyLoginComponent implements OnInit {
  trackingScreenName: TrackingScreenNamesEnum;
  trackingObject$: Observable<ITrackingObject>;
  resultIcon$: Observable<IIcon>;
  title$: Observable<string>;
  subtitle$: Observable<string>;
  loginAttemptResult$: Observable<LoginAttemptResult>;

  constructor(
    private _router: ActivatedRoute,
    private _verifyLoginBuilder: VerifyLoginBuilder,
    private _accountDispatcher: AccountDispatcher,
    private _accountStore: AccountStore,
    private _trackingService: I2gNgTrackingService
  ) {}

  ngOnInit() {
    const queryParamMap = this._router.snapshot.queryParamMap;

    this.trackingScreenName =
      TrackingScreenNamesEnum.unusual_login_verification_result;

    this._accountDispatcher.verifyUnusualLogin(
      queryParamMap.get(LOGIN_ATTEMPT_ID),
      queryParamMap.get(VERIFICATION_CODE)
    );

    this.loginAttemptResult$ = this._accountStore.getLoginAttemptResult();

    const result$ = merge(
      this.loginAttemptResult$,
      this._accountStore.getUnusualLoginError()
    ).pipe(
      filter((x) => !!x),
      take(1),
      map((result) => result instanceof LoginAttemptResult),
      tap((result) =>
        this._trackingService.trackPage(this.trackingScreenName, {
          success: result,
        })
      ),
      shareReplay(1)
    );

    this.resultIcon$ = result$.pipe(
      map((result: boolean) => ({
        name: result ? 'success' : 'error-reset',
        size: IconSizesEnum.custom,
      }))
    );

    this.title$ = result$.pipe(
      map((result: boolean) => this._verifyLoginBuilder.buildTitle(result))
    );

    this.subtitle$ = result$.pipe(
      map((result: boolean) => this._verifyLoginBuilder.buildSubTitle(result))
    );
  }
}
